import { ImagesService } from './../../service/images.service';
import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Output, EventEmitter, OnDestroy, ComponentFactoryResolver } from '@angular/core';
import { Location } from '@angular/common';
import { SearchService } from '../../service/search.service';
import { Router, ActivatedRoute, Params, ParamMap } from '@angular/router';
import 'parse';
const parse: typeof Parse = require('parse');
import { map, filter } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { CacheService } from '../../service/cache.service';
import { TchekService, GetTchekOpts } from '../../service/tchek.service';
import { t } from '@angular/core/src/render3';
import { Moment } from 'moment';
import { FormControl } from '@angular/forms';
import { ViewEncapsulation } from '@angular/core';
import { Tchekb } from '../../model/tchekb.model';
import { AwsService } from '../../service/aws.service';
import { HydratedTchek } from '../../model/tchekb.model';
import { ToastService } from '../../service/toast.service';
import { SearchTag, AdminSearch, Attributes, TchekStatus, Device, FinderData } from '../../model/search';
import { DamageService } from '../../service/damage.service';
import { LocalstorageService } from '../../service/localstorage.service';
import { I18n } from '@ngx-translate/i18n-polyfill';

declare let $: any;

@Component({
  selector: 'app-finder',
  templateUrl: './finder.component.html',
  styleUrls: ['./finder.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FinderComponent implements OnInit, OnDestroy {
  private _dashChar = '\u2014';
  private _holdClickRate = 200;
  private intervalIdL: any;
  private intervalIdH: any;
  private cd: ChangeDetectorRef;
  private vehicleCount: number;

  statuses: TchekStatus[];
  cpt: number;

  getTchekOptions = {
    limit: 10,
    includeThumbnail: true,
    sort: 'latest'
  } as GetTchekOpts;
  moment = require('moment/moment');

  ranges: any = {}

  @Output() searchResults: EventEmitter<Array<Parse.Object>> = new EventEmitter();
  @Output() loading: EventEmitter<Object> = new EventEmitter();
  @Output() clearFilter: EventEmitter<string> = new EventEmitter();
  @Output() searchTriggered: EventEmitter<Array<SearchTag>> = new EventEmitter();

  deviceLoader: boolean;
  isSuperAdmin: boolean = false;
  subscription: Subscription[] = [];
  tcheks: Array<Tchekb>;
  devicesSelector: Device[];

  finderData: FinderData;

  placeHolderImmatSearch = this.i18n({
    id: 'matriculationSearch',
    value: 'Immatriculation...',
    meaning: "export-kpi"
  })

  onChangeSelect(deviceValue) {
    this.finderData.skip = 0;
    this.fuzzySearch();
  }

  checkValue() {
    this.finderData.skip = 0;
    this.fuzzySearch();
  }

  inspectList() {
    let tcheksImages = this.tcheks.filter(t => { return ([4,5,2].includes(t.type)) })
    this._damageService.getModelIa().then(res => {
      let model = res[0].name
      console.log('tcheks image : ', tcheksImages);
      tcheksImages.forEach(tchek => {
        this._imageService.runDetectionTchekImage(tchek.id, model)
      })
    })
  }

  goToClassificationImages() {
    this._router.navigate(['/classificationImage']);
  }

  constructor(
    private readonly i18n: I18n,
    private cdRef: ChangeDetectorRef,
    private _router: Router,
    public _searchService: SearchService,
    private readonly _tchekService: TchekService,
    private _route: ActivatedRoute,
    private _location: Location,
    private _imageService: ImagesService,
    private _awsService: AwsService,
    private readonly _toastService: ToastService,
    private readonly _damageService: DamageService,
    private _localStorageService: LocalstorageService) {

    this.ranges[this.i18n({
      id: 'today',
      value: "Aujourd'hui",
      meaning: "export-kpi"
    })] = [this.moment(), this.moment()];
    this.ranges[this.i18n({
      id: 'yesteray',
      value: "Hier",
      meaning: "export-kpi"
    })] = [this.moment().subtract(1, 'days'), this.moment().subtract(1, 'days')];
    this.ranges[this.i18n({
      id: 'lastWeek',
      value: "Les 7 derniers jours",
      meaning: "export-kpi"
    })] = [this.moment().subtract(29, 'days'), this.moment()];
    this.ranges[this.i18n({
      id: 'last30Days',
      value: "Les 30 derniers jours",
      meaning: "export-kpi"
    })] = [this.moment().subtract(29, 'days'), this.moment()];
    this.ranges[this.i18n({
      id: 'thisMonth',
      value: 'Ce Mois',
      meaning: "export-kpi"
    })] = [this.moment().startOf('month'), this.moment().endOf('month')];
    this.ranges[this.i18n({
      id: "lastMonth",
      value: "Le Mois dernier",
      meaning: "export-kpi"
    })] = [this.moment().subtract(1, 'month').startOf('month'), this.moment().subtract(1, 'month').endOf('month')];

    this.statuses = [
      new TchekStatus('litigation', this.i18n({
        id: "litigation",
        value: "En litige",
        description: "En litige",
        meaning: "finder"
      })),
      new TchekStatus('inspected', this.i18n({
        id: "inspected",
        value: "Inspecté",
        description: "Inspecté",
        meaning: "finder"
      })),
      new TchekStatus('unread', this.i18n({
        id: "unread",
        value: "Non lu",
        description: "Non lu",
        meaning: "finder"
      })),
      new TchekStatus('read', this.i18n({
        id: "read",
        value: "Traité",
        description: "Traité",
        meaning: "finder"
      })),
      new TchekStatus('processing', this.i18n({
        id: "processing",
        value: "En chargement",
        description: "En chargement",
        meaning: "finder"
      }))
    ];

    this.cpt = -1;

    this.deviceLoader = true;
    this.isSuperAdmin = parse.User.current().get('isSuperAdmin');

    if (!this.devicesSelector) {
      this.devicesSelector = [];
      this._searchService.getDevices().then(alldev => {
        alldev.forEach(device => {
          this.devicesSelector.push({
            id: device.id,
            name: device.get('serialNumber') +
              ((this.isSuperAdmin || parse.User.current().get('roleCompany') === 'R_Tchek' || parse.User.current().get('roleCompany') === 'R_Tscan') ? (' ' + device.get('name')) : '')
          });
        });
        if (this.devicesSelector)
          this.devicesSelector.sort((a, b) => {
            if (a.name < b.name) { return -1; }
            if (a.name > b.name) { return 1; }
            return 0;
          })
        this.deviceLoader = false;
      })
    }
    this.cd = cdRef;


    const observablesPair = this._tchekService.subscribeTcheks(this.getTchekOptions);
    this.subscription[3] = observablesPair.plusOneObservable.subscribe(this.tchekAddedObserver.bind(this));
    this.subscription[4] = observablesPair.minusOneObservable.subscribe(this.tchekRemovedObserver.bind(this));
    this.subscription[5] = observablesPair.changedObservable.subscribe(this.tchekChangedObserver.bind(this));



    this.subscription[1] = this._searchService.vehicleHistoryObs.subscribe(immat => {
      if (!this.finderData)
        return
      this.finderData.skip = 0;
      this.finderData.activeFilters = [{ display: immat, value: immat }];
      this.finderData.date = undefined;
      this.finderData.searchTags = [{ display: immat, value: immat }];
      this.finderData.limit = 100;
      this.finderData.isDateActive = false;
      this.fuzzySearch();
    })

    this.subscription[2] = this._searchService.readMoreObs.subscribe(() => {
      this.fuzzySearch();
    })

    console.log('constructor finder');
    this._searchService.getFinderData().then(f => {
      this.finderData = f
      this.finderData.skip = 0
      this.fuzzySearch();
      console.log("finderdata into finder ", this.finderData);
    })
  }

  onChangeStatus(status) {
    this.finderData.skip = 0;
    this.loading.emit({ loading: true, isSearching: !this.verif() });
    this.fuzzySearch()
  }


  onChangeDevice(device) {
    this.finderData.skip = 0;
    this.loading.emit({ loading: true, isSearching: !this.verif() });
    this.fuzzySearch()
  }

  ngOnDestroy(): void {
    this.subscription.forEach(sub => sub.unsubscribe());
  }

  ngOnInit() {

  }

  async tchekAddedObserver(tchek: HydratedTchek) {
    this._toastService.toastOpen(undefined,
      this.i18n({
        id: "newScan",
        value: "Nouveau Scan",
        description: "Nouveau Scan",
        meaning: "finder"
      }));
    let validate = true;

    tchek.vehiclePtr = await this._tchekService.get(tchek.id).then(tchek => {
      return tchek.vehiclePtr;
    })
    if (this.finderData.isDateActive) {
      if (this.moment(tchek.tchekCreatedAt) > this.finderData.date.end)
        validate = false;
      if (this.moment(tchek.tchekCreatedAt) < this.finderData.date.start)
        validate = false;
    }
    if (this.finderData.activeFilters.length > 0) {
      this.finderData.activeFilters.forEach(filter => {
        if (tchek.vehiclePtr.immat.includes(filter.value.toString().toUpperCase()) === false)
          validate = false;
      });
    }
    if (this.finderData.statusSelect !== null) {
      switch (this.finderData.statusSelect) {
        case 'unread':
          validate = tchek.isNew === true;
          break;
        case 'read':
          validate = tchek.isNew === false;
          break;
        case 'litigation':
          validate = tchek.isFlagged === true;
          break;
        case 'processing':
          validate = tchek.detectionFinished === false;
          break;
        default:
          console.log('ERROR No activeStatus');
      }
    }
    if (this.finderData.isPicturesHD !== undefined) {
      validate = tchek.uploadHDPictures === this.finderData.isPicturesHD;
    }
    if (this.finderData.isPicturesXHD !== undefined) {
      validate = tchek.uploadHDPictures === this.finderData.isPicturesXHD;
    }
    if (this.finderData.scanAnnotated !== undefined) {
      validate = tchek.isAnnotated === this.finderData.scanAnnotated;
    }
    if (this.finderData.deviceSelect !== null) {
      if (this.finderData.deviceSelect !== tchek.devicePtr.id)
        validate = false;
    }
    if (this.isSuperAdmin && this.finderData.admin && this.finderData.admin.searchTagList)
      Object.values(this.finderData.admin.searchTagList)
        .forEach(list => {
          list.forEach(e => {
            if (e.checked === true)
              validate = false;
          })
        })
    if (validate) {
      this.finderData.skip++;
      const i = this.tcheks.findIndex(t => tchek.tchekCreatedAt > t.tchekCreatedAt);
      const cpPromises = [];
      cpPromises[0] = this._awsService.generateUrlPromise(tchek.thumbnailUrl, tchek.devicePtr.ipMachine);
      Promise.all(cpPromises).then(resolvedPromises => {
        tchek.thumbnailUrl = resolvedPromises[0]
        this.tcheks.splice(i, 0, tchek);
      })
    }

  }

  tchekRemovedObserver(tchek: Tchekb) {
    const index = this.tcheks.findIndex(t => t.id === tchek.id);
    if (index > -1)
      this.tcheks.splice(index, 1);
  }


  tchekChangedObserver(tchek: HydratedTchek) {
    //  console.log('change tchek', tchek);
    if (tchek.isDeleted === true) { this.tchekRemovedObserver(tchek) }
    else if (this.tcheks) {
      const index = this.tcheks.findIndex(t => t.id === tchek.id);
      if (index > -1) {
        const cpPromises = [];
        cpPromises[0] = this._awsService.generateUrlPromise(tchek.thumbnailUrl, tchek.devicePtr.ipMachine);
        Promise.all(cpPromises).then(resolvedPromises => {
          tchek.thumbnailUrl = resolvedPromises[0]
          this.tcheks.splice(index, 1, tchek);
        })
        this.setData()
      }
    }
  }

  updateSearchTags(tags: SearchTag[]) {
    this.finderData.skip = 0;
    this.finderData.searchTags = tags;
    this.loading.emit({ loading: true, isSearching: !this.verif() });
    this.loading.emit({ loading: true, isSearching: !this.verif() });
    this.fuzzySearch(tags);
  }

  focusInput(value) {
    if (value)
      $('#search-wrapper').addClass('focused');
    else
      $('#search-wrapper').removeClass('focused');
  }


  updateSearchTagsAdmin(event) {
    console.log('updateSearchTagsAdmin event : ', event);
    this.loading.emit({ loading: true, isSearching: !this.verif() });
    this.fuzzySearch()
  }

  updateSearchDate(date: { start: Moment, end: Moment }) {
    this.cpt++;
    //console.log("fuzzy updateSearchDate date", this.cpt);
    this.finderData.skip = 0;
    if (!(date.start === null || date.end === null
      || date.start === undefined || date.end === undefined)) {
      this.finderData.date.start = date.start;
      this.finderData.date.end = date.end;
      this.finderData.isDateActive = true;
    } else {
      this.finderData.date = undefined;
      this.finderData.isDateActive = false;
    }
    if (this.cpt === 0)
      return;

    this.loading.emit({ loading: true, isSearching: !this.verif() });
    this.fuzzySearch()
  }

  erasedate() {
    this.finderData.skip = 0;
    this.finderData.date = undefined;
    this.finderData.isDateActive = false;
    this.cpt = -1;
    this.loading.emit({ loading: true, isSearching: !this.verif() });
    this.fuzzySearch()
  }

  fuzzySearch(newFilters?: SearchTag | Array<SearchTag>) {

    console.log('search finder = ', !this.verif())

    console.log("fuzzy start", this.finderData, this.cpt);
    if (this.finderData.activeFilters && !newFilters)
      newFilters = this.finderData.activeFilters

    $('#search-input').val('').trigger('blur');
    if (newFilters !== undefined && !Array.isArray(newFilters))
      newFilters = [newFilters];
    else if (newFilters === undefined)
      newFilters = [];
    this.finderData.activeFilters = newFilters as SearchTag[];
    // Emitting to parent that search is triggered
    this.searchTriggered.emit(this.finderData.activeFilters);

    if (!this.tcheks || this.finderData.skip > this.tcheks.length)
      this.finderData.skip = 0

    this._searchService.fuzzySearch(this.finderData)
      .then(  (result) => {
        result.filter(a => { return a !== undefined })

            // console.log("result count ", resultCount)
            const cpPromises = [];
            var i = 0
            result.forEach(tchek => {
              if (tchek.immatPicture) {
                cpPromises[i] = this._awsService.generateUrlPromise(tchek.immatUrl, tchek.devicePtr.ipMachine);
                i++
              }
            });
            Promise.all(cpPromises).then( resolvedPromises => {
              var i = 0
              result.forEach(tchek => {
                if (tchek.immatPicture) {
                  tchek.immatUrl = resolvedPromises[i]
                  i++
                }
              });

              const cpPromises = [];
              var i = 0
              result.forEach(tchek => {
				  if (tchek.type !== 4  || this.isSuperAdmin)
                cpPromises[i] = this._awsService.generateUrlPromise(tchek.thumbnailUrl, tchek.devicePtr.ipMachine);
                i++
              });
              Promise.all(cpPromises).then(async resolvedPromises => {
                var i = 0
                result.forEach(tchek => {
                  tchek.thumbnailUrl = resolvedPromises[i]
                  i++
                });

                let tmp = []
                if (this.finderData.skip > 0 && this.tcheks)
                  this.tcheks.forEach(t => {
                    let include = true;
                    result.forEach(r => {
                      if (r.id === t.id)
                        include = false;
                    });
                    if (include)
                      tmp.push(t)
                  })
                result = tmp.concat(result)
                this.tcheks = result;
                this.finderData.skip = result.length;

				if (!this.verif() && ( this._searchService.lastFinderData === undefined ||
					this._searchService.lastFinderData !== JSON.stringify(this.finderData)
					)){
						this._searchService.lastFinderData = JSON.stringify(this.finderData)
						this._searchService.searchCount  =  await this._searchService.fuzzySearchCount(this.finderData)
					} 
					let resultCount = this._searchService.searchCount

                console.log("fuzzy end", this.finderData, this.cpt, "resultcount", resultCount);

                this.loading.emit({ loading: false, isSearching: !this.verif(), count: resultCount });

                this._searchService.setTchekList(this.tcheks)
                this.searchResults.emit(result);
              })
            })
         }, error => console.error('Could not query search to Parse ', error.code, error.message));

    this.setData()
  }

  verif(): boolean {
    if (this.cpt <= 0
      && this.finderData.activeFilters
      && this.finderData.activeFilters.length === 0
      && this.finderData.isDateActive === false
      && this.finderData.deviceSelect === null
      && this.finderData.isDownloaded === undefined
      && this.finderData.isPicturesHD === undefined
      && this.finderData.isPicturesXHD === undefined
      && this.finderData.scanAnnotated === undefined
      && this.finderData.scanForValidation === undefined
      && this.finderData.scanAnalyzed === undefined
      && this.finderData.minProbVehicle === undefined
      && (this.finderData.statusSelect === undefined || this.finderData.statusSelect === null)
      && this.finderData.limit === 15
    ) {
      if (this.isSuperAdmin === true && this.finderData.admin
        && this.finderData.admin.annotateSearch !== false
        && this.finderData.admin.damageSearch !== false)
        return false;
      else
        return true;

    } else
      return false;
  }

  setData() {
    if (this.finderData.isDateActive) {
      this.finderData.sDate = { start: undefined, end: undefined };
      this.finderData.sDate.start = this.finderData.date.start.toDate()
      this.finderData.sDate.end = this.finderData.date.end.toDate()
    }
    this._searchService.setFinderData(this.finderData);
  }
}



// WEBPACK FOOTER //
// ./src/app/element/finder/finder.component.ts